import z from 'zod';
export const currencyCodeValue = z.enum(['EUR']);
export const moneyValue = z.object({
    amountInCents: z.number().int().nonnegative(),
    currency: currencyCodeValue,
});
export const createMoney = (value) => moneyValue.parse(value);
export const isMoney = (value) => moneyValue.safeParse(value).success;
export function areMoneyAmountsEqual(first, second) {
    return first.amountInCents === second.amountInCents;
}
export function createMoneyFromCents(amountInCents, currency = 'EUR') {
    return moneyValue.parse({
        amountInCents,
        currency,
    });
}
export function createMoneyFromEurosHT(eurosHT) {
    const euros = z.number().int().nonnegative().parse(eurosHT);
    return moneyValue.parse({
        amountInCents: euros * 100,
        currency: 'EUR',
    });
}
//# sourceMappingURL=money.js.map